var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('dynamic-form', { ref: "form", attrs: { "form-config": _vm.formConfig, "form-value": _vm.formValue, "form-item-list": _vm.formItemList } });
};
var staticRenderFns = [];

export { render, staticRenderFns };